export var IdResource;
(function (IdResource) {
    IdResource[IdResource["AdventureCoins"] = 165] = "AdventureCoins";
    IdResource[IdResource["Books"] = 53] = "Books";
    IdResource[IdResource["BuildCoupons"] = 105] = "BuildCoupons";
    IdResource[IdResource["ChestKeys"] = 124] = "ChestKeys";
    IdResource[IdResource["CoopFunds"] = 74] = "CoopFunds";
    IdResource[IdResource["DecoCoupons"] = 57] = "DecoCoupons";
    IdResource[IdResource["DogtreatPremium"] = 235] = "DogtreatPremium";
    IdResource[IdResource["DogtreatStandard"] = 70] = "DogtreatStandard";
    IdResource[IdResource["FertilizerSeaweed"] = 119] = "FertilizerSeaweed";
    IdResource[IdResource["Gold"] = 2] = "Gold";
    IdResource[IdResource["HumusSeaweed"] = 96] = "HumusSeaweed";
    IdResource[IdResource["InkSets"] = 52] = "InkSets";
    IdResource[IdResource["LoyaltyPoints"] = 23] = "LoyaltyPoints";
    IdResource[IdResource["Money"] = 1] = "Money";
    IdResource[IdResource["PawPrints"] = 239] = "PawPrints";
    IdResource[IdResource["Scrolls"] = 51] = "Scrolls";
    IdResource[IdResource["Snippets"] = 125] = "Snippets";
    IdResource[IdResource["SpecialCoupons"] = 106] = "SpecialCoupons";
    IdResource[IdResource["TournamentCoins"] = 101] = "TournamentCoins";
    IdResource[IdResource["Water"] = 66] = "Water";
    IdResource[IdResource["VictoryCoins"] = 277] = "VictoryCoins";
})(IdResource || (IdResource = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdResource.ts
// module id = 15
// module chunks = 3